import useCurrentUser from "../hooks/useCurrentUser";
import Topbar from "../components/Topbar";
import GoBackLink from "../components/GoBackLink";
import { useState, useEffect } from "react";
import axios from "axios";
import useCookie from "../hooks/useCookie";
import "../css/DigitalArtPage.css";

function PixelArt() {
    const prod_pixelart = "https://fractal-digital-art-ejdsgwajavgphrfd.eastus2-01.azurewebsites.net";
    const dev_pixelart = "http://localhost:8080";

    let pixelArtOrigin;
    if (process.env.REACT_APP_ENVIRONMENT == "prod"){
        pixelArtOrigin = prod_pixelart;
    } else {
        pixelArtOrigin = dev_pixelart;
    }

    let user = null;
    user = useCurrentUser();

    const csrftoken = useCookie("csrftoken");
    const headers = {
        "X-CSRFToken": csrftoken,
    };

    // Gallery IDs - used to save image to profile
    const [recentGallery, setRecentGallery] = useState(-1); // "Recent" gallery ID
    const [savedGallery, setSavedGallery] = useState(-1); // "Saved" gallery ID

    // Get recent and saved IDs once we have user
    useEffect(() => {
        getIDs();
    }, [user]);

    // Get recent and saved gallery IDs for this user
    const getIDs = () => {
        if (user) {
            // Grab gallery IDs
            if (user.is_staff) {
                if (user.is_superuser) { // User is Admin
                    axios.get("/api/admins/" + user.id)
                    .then((response) => {
                        let teacher = response.data;
                        setRecentGallery(teacher.recent);
                        setSavedGallery(teacher.saved);              
                    });
                } else { // User is Teacher
                    axios.get("/api/teachers/" + user.id)
                    .then((response) => {
                        let teacher = response.data;
                        setRecentGallery(teacher.recent);
                        setSavedGallery(teacher.saved);              
                    });
                }
            } else { // User is Student
                axios.get("/api/students/" + user.id)
                .then((response) => {
                    let student = response.data;
                    setRecentGallery(student.recent);
                    setSavedGallery(student.saved);
                });
            }
        }
    };

    // Save image to recent and saved galleries
    const saveImage = (event) => {
        try {
            let message = JSON.parse(event.data);
            if (event.origin == pixelArtOrigin) {
                if (recentGallery != -1 && savedGallery != -1) {
                    let imgObj = {
                        "prompt": message.coloringSheet != null ? (message.coloringSheet) : "No coloring sheet",
                        "picture": message.base64,
                        "studio": "PIX_ART"
                    };

                    let iframe = document.getElementById("pixel-art-iframe");

                    // Post to recent gallery
                    imgObj["gallery"] = recentGallery;
                    axios.post("/api/images/", imgObj, { headers })
                    .then((response) => {
                        // Post to saved gallery
                        imgObj["gallery"] = savedGallery;
                        axios.post("/api/images/", imgObj, { headers })
                        .then((response) => {
                            // Send a response back to pixel art app
                            iframe.contentWindow.postMessage("FractalImageSave Success", '*');
                        }).catch((error) => {
                            iframe.contentWindow.postMessage("FractalImageSave Error: " + error, '*');
                        });
                    }).catch((error) => {
                        iframe.contentWindow.postMessage("FractalImageSave Error: " + error, '*');
                    });
                }
            }
        } catch (error) {
            console.log(error);
        }        
    };

    useEffect(() => {
        // iframe sends a message to this parent when an image is saved
        // Save image to recent and saved galleries
        window.addEventListener("message", saveImage);  

        // Ensure that image is saved only twice when message is received 
        // (once to recent gallery, once to saved gallery)
        return function() {
            window.removeEventListener("message", saveImage);
        }
    })
     

    return (
        <div className = "page-with-splash">
            <Topbar isExplorePage = {true} />
            <GoBackLink pageName = "Explore" pageLink = "/explore" />
            <iframe id="pixel-art-iframe" src={pixelArtOrigin} /> {/* Pixel art app */}
        </div>
    )
}

export default PixelArt;